import React from 'react';
import { connect } from "react-redux";
import {Select} from "antd";

//action imports
import { serviceFieldChanged } from "../../../actions/ServicesActions";
import {Spinner} from "../../common/Spinner";


class FilterEnquires extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            enquiryFilter: this.props.enquiryFilter,
            legalServices: this.props.legalServices,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.enquiryFilter !== this.props.enquiryFilter) {
            this.setState({ enquiryFilter: nextProps.enquiryFilter });
        }

        if (nextProps.legalServices !== this.props.legalServices) {
            this.setState({ legalServices: nextProps.legalServices });
        }
    }

    render() {
        const { legalServices } = this.state;

        if (legalServices.length === 0) {
            return <Spinner/>
        } else {
            return (
                <div className={"inputTypeSelect"}>
                    <div>
                        <p>Filter Enquiries</p>
                    </div>
                    <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder={"Filter"}
                        optionFilterProp="children"
                        onChange={value => this.props.serviceFieldChanged({ prop: "enquiryFilter", value })}
                        value={this.state.enquiryFilter}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <option value={""}>All</option>
                        {
                            legalServices.map(service => <option value={service.legalServiceID}>{service.legalServiceTitle}</option>)
                        }
                    </Select>
                </div>
            );
        }
    }
}

const mapStateToProps = state => {
    const { enquiryFilter, legalServices } = state.services;

    return {
        enquiryFilter,
        legalServices
    }
};

export default connect(mapStateToProps, {serviceFieldChanged})(FilterEnquires);